<template>
	<ul class="v5-x-checklist">
		<li v-for="(item, index) in options" :key="item.id" class="v5-x-checklist-item">
			<label :for="`v5-x-checklist-${uuid}-${index}`">
				<input type="checkbox" class="v5-x-checklist-checkbox" :name="`v5-x-checklist-${uuid}`" :id="`v5-x-checklist-${uuid}-${index}`" :value="item.id" v-model="currentValue" :disabled="isDisabled(item)" @change="change(item)">
				<slot :props="item"></slot>
			</label>
		</li>
	</ul>
</template>

<script>
import uuidMixin from './../../mixins/uuid';
export default {
	name: 'v5-x-checklist',
	mixins: [uuidMixin],
	props: {
		options: {
			type: Array
		},
		value: {
			type: Array,
			default: () => []
		},
		max: {
			type: Number,
			default: 3
		}
	},
	computed: {
		limit() {
			return this.currentValue.length > this.max;
		}
	},
	watch: {
		value(val) {
			this.setCurrentValue(val);
		},
		options(val) {
			this.createIndex(val);
		}
	},
	methods: {
		change(item) {
			if (this.limit) {
				this.$emit('on-limit');
				this.currentValue.pop();
				return;
			}
			item['checked'] = !item['checked'];
			this.$emit('input', this.getValue());
		},
		isDisabled(item) {
			if (item['checked']) {
				return false;
			}
			if (this.currentValue.length > this.max) {
				return true;
			}
			return false;
		},
		createIndex(arr) {
			arr.forEach(item => {
				//添加选中状态
				item['checked'] = this.currentValue.indexOf(item.id) !== -1;
				//建立索引
				this.indexing[item.id] = item;
			});
		},
		getValue() {
			return this.currentValue.map(item => {
				return this.indexing[item];
			});
		},
		setCurrentValue(arr) {
			this.currentValue = Array.map(arr, item => {
				if (this.indexing[item.id]) {
					this.indexing[item.id]['checked'] = true;
				}
				return item.id;
			});
		}
	},
	data() {
		return {
			indexing: {}, //索引
			currentValue: []
		};
	},
	created() {
		//转换
		this.setCurrentValue(this.value);
		//生成列表数据索引
		this.createIndex(this.options);
	}
};
</script>

<style lang="scss">
@import './style.scss';
</style>



// WEBPACK FOOTER //
// index.vue?3676195c